export const OPTIONS = {
  adverseReaction: [
    {
      label: 'Patient died',
      value: 'PATIENT_DIED',
    },
    {
      label: 'Involved or prolonged inpatient hospitalisation',
      value: 'HOSPITALISATION',
    },
    {
      label: 'Involved persistence or significant disability or incapacity',
      value: 'DISABILITY_OR_INCAPACITY',
    },
    {
      label: 'Life threatening',
      value: 'LIFE_THREATENING',
    },
    {
      label: 'Is a congenital anomaly/ birth defect',
      value: 'IS_DEFECT',
    },
    {
      label: 'Is a medically important event',
      shortLabel: 'Is a medically important event',
      value: 'IS_MEDICALLY_EVENT',
    },
    {
      label: 'N/A – Adverse Event of Special Interest',
      value: 'NA',
    },
  ],
  reactionAbate: [
    {
      label: 'Yes',
      value: 'YES',
    },
    {
      label: 'No',
      value: 'NO',
    },
    {
      label: 'NA',
      value: 'NA',
    },
  ],
  reactionReappear: [
    {
      label: 'Yes',
      value: 'YES',
    },
    {
      label: 'No',
      value: 'NO',
    },
    {
      label: 'NA',
      value: 'NA',
    },
  ],
  reportSource: [
    {
      label: 'Study',
      value: 'STUDY',
    },
    {
      label: 'Literature',
      value: 'LITERATURE',
    },
    {
      label: 'HCP',
      value: 'HCP',
    },
  ],
  reportType: [
    {
      label: 'Initial',
      value: 'INITIAL',
    },
    {
      label: 'Followup',
      value: 'FOLLOW_UP',
    },
  ],
};
